module.exports = __webpack_public_path__ + "img/img_txt_activity02.26aa260f.png";